import { createSlice } from '@reduxjs/toolkit';
import { ECurrentModalStep } from "../../types";
import { selectInitialActiveCategory, selectInitialActiveTab, selectIsModalStepSearch } from "./selectors";
var initialState = {
  isMenuModalOpen: false,
  activeCategory: null,
  activeTab: null,
  currentModalStep: ECurrentModalStep.menu
};
var menuSlice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    toggleModalMenuOpen: function toggleModalMenuOpen(state) {
      state.isMenuModalOpen = !state.isMenuModalOpen;
    },
    showMenuModal: function showMenuModal(state) {
      state.isMenuModalOpen = true;
    },
    setInitialCategoryAndTab: function setInitialCategoryAndTab(state, _ref) {
      var payload = _ref.payload;
      state.activeCategory = payload.activeCategory;
      state.activeTab = payload.activeTab || null;
    },
    setActiveCategory: function setActiveCategory(state, _ref2) {
      var payload = _ref2.payload;
      state.activeCategory = payload;
      state.activeTab = null;
    },
    setActiveTab: function setActiveTab(state, _ref3) {
      var payload = _ref3.payload;
      state.activeTab = payload;
    },
    setCurrentModalStep: function setCurrentModalStep(state, _ref4) {
      var payload = _ref4.payload;
      state.currentModalStep = payload;
    }
  }
});
export var toggleModalMenu = function toggleModalMenu() {
  return function (dispatch, getState) {
    var activeCategory = selectInitialActiveCategory(getState());
    var activeTab = selectInitialActiveTab(getState());
    dispatch(setInitialCategoryAndTab({
      activeCategory: activeCategory,
      activeTab: activeTab
    }));
    dispatch(toggleModalMenuOpen());
  };
};
export var actionToggleModalMenu = function actionToggleModalMenu() {
  return function (dispatch, getState) {
    var stepSearch = selectIsModalStepSearch(getState());
    if (stepSearch) {
      dispatch(setCurrentModalStep(ECurrentModalStep.menu));
    } else {
      dispatch(toggleModalMenuOpen());
    }
  };
};
export var actionToggleSearchStepMenu = function actionToggleSearchStepMenu() {
  return function (dispatch, getState) {
    var stepSearch = selectIsModalStepSearch(getState());
    var step = stepSearch ? ECurrentModalStep.menu : ECurrentModalStep.search;
    dispatch(setCurrentModalStep(step));
  };
};
var _menuSlice$actions = menuSlice.actions,
  toggleModalMenuOpen = _menuSlice$actions.toggleModalMenuOpen,
  showMenuModal = _menuSlice$actions.showMenuModal,
  setActiveCategory = _menuSlice$actions.setActiveCategory,
  setActiveTab = _menuSlice$actions.setActiveTab,
  setCurrentModalStep = _menuSlice$actions.setCurrentModalStep,
  setInitialCategoryAndTab = _menuSlice$actions.setInitialCategoryAndTab;
export { toggleModalMenuOpen, showMenuModal, setActiveCategory, setActiveTab, setCurrentModalStep, setInitialCategoryAndTab };
export var menu = menuSlice.reducer;